// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JsgSd","toggle":"styles_toggle__eC1hT","preview":"styles_preview__2eTD0"};